import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequiredConfigurationLoadedGuard } from './core/guards/required-configuration-loaded.guard';
import { LOGIN_PATH, ROOT_PATH } from './core/utils/application-structure';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROOT_PATH,
  },
  {
    path: ROOT_PATH,
    canLoad: [RequiredConfigurationLoadedGuard],
    canActivate: [RequiredConfigurationLoadedGuard],
    canActivateChild: [RequiredConfigurationLoadedGuard],
    loadChildren: () => import('./features/navigation/navigation.module').then((m) => m.NavigationModule),
  },
  {
    path: LOGIN_PATH,
    loadChildren: () => import('./features/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '**',
    redirectTo: ROOT_PATH,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
